import type { ReactNode } from 'react';
import styles from './PanelActions.module.css';

export interface PanelActionsProps {
	children: ReactNode;
}

export const PanelActions = ({ children }: PanelActionsProps) => (
	<div className={styles.actions}>{children}</div>
);
